import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const dashboard = {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
}